import { render } from "./HeroSection.vue?vue&type=template&id=210a7aa2&scoped=true"
import script from "./HeroSection.vue?vue&type=script&lang=js"
export * from "./HeroSection.vue?vue&type=script&lang=js"

import "./HeroSection.vue?vue&type=style&index=0&id=210a7aa2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guifernandespro\\development\\projects\\vue_icon-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210a7aa2"]])

export default __exports__